import './_blog-article-text.scss';